<!-- loader -->
<div *ngIf="!arrTable[0]" class="loader-container" id="mainq">
    <div class="loader"></div>
</div>

<!-- questionary form -->
<form #questionaryform="ngForm" name="questionaryform" id="questionaryform" *ngIf="arrTable[0] && arrTable[0].questionaryanswerstatusid != 2">
    <input [(ngModel)]="questionaryid" type="hidden" name="questionaryid" />
    <input [(ngModel)]="pagenumber" type="hidden" name="pagenumber" />
    <input [(ngModel)]="questionaryanswerhashcode" type="hidden" name="questionaryanswerhashcode" />

    <div class="container" id="mainq">
        <div class="qinner {{closingclass}}">

            <!-- loop questions -->
            <div *ngFor="let table of arrTable1" data-questionaryquestiontypecode="{{table.questionaryquestiontypecode}}" data-questionaryquestionid="{{table.questionaryquestionid}}">

                <!-- separator: html -->
                <div *ngIf="table.questionaryquestiontypecode == 'separatorhtml'" class="questionwrapper">
                    <div *ngIf="table.title != ''" class="questionseparatorhtmltitle" [innerHTML]="table.title | safeHtml"></div>
                    <div *ngIf="table.description != ''" class="questionseparatorhtmldescription" [innerHTML]="table.description | safeHtml"></div>
                </div>

                <!-- separator: text -->
                <div *ngIf="table.questionaryquestiontypecode == 'separatortext'" class="questionwrapper">
                    <div *ngIf="table.title != ''" class="questionseparatortexttitle" [innerHTML]="table.title | safeHtml"></div>
                    <div *ngIf="table.description != ''" class="questionseparatortextdescription" [innerHTML]="table.description | safeHtml"></div>
                </div>

                <!-- matrix single column radio -->
                <div *ngIf="table.questionaryquestiontypecode == 'matrixsinglecolumnradio'">

                    <!-- question title -->
                    <div *ngIf="table.title != '' && table.questionwithrequired == 1" class="questiontitle" data-pictos-questionary-required="&#xF069;" title="Answer required.">{{ table.title }}</div>
                    <div *ngIf="table.title != '' && table.questionwithrequired != 1" class="questiontitle">{{ table.title }}</div>

                    <!-- question description -->
                    <div *ngIf="getMatrixFirst(table.questionaryquestionid).description != ''" class="questiondescription" [innerHTML]="getMatrixFirst(table.questionaryquestionid).description | safeHtml"></div>

                    <!-- items -->
                    <div style="display: table;">

                        <ng-container *ngFor="let matrixrow of getMatrixRows(table.questionaryquestionid, getMatrixFirst(table.questionaryquestionid).columncount); let matrixrowindex = index;">

                            <!-- options -->
                            <ng-container *ngFor="let matrixcolumn of getMatrixRowColumns(table.questionaryquestionid, getMatrixFirst(table.questionaryquestionid).columncount, matrixrowindex); let matrixcolumnindex = index;">

                                <input *ngIf="matrixrowindex == 0" type="hidden" [required]="matrixcolumn.required" pattern="^[1-9]\d*$" [name]="getMatrixName(table.questionaryquestionid, matrixrow.questionaryquestionmatrixcolumnid, matrixrow.pagenumber, table.questionaryquestiontypecode)" [(ngModel)]="table.value" />
                                <div class="radio-button">
                                    <label>
                                        <input type="radio" hidden
                                               [name]="getMatrixName(table.questionaryquestionid, matrixrow.questionaryquestionmatrixcolumnid, matrixrow.pagenumber, table.questionaryquestiontypecode) + '_radio'"
                                               [value]="matrixcolumn.questionaryquestionmatrixrowid"
                                               [checked]="matrixcolumn.questionaryquestionmatrixrowid == matrixcolumn.valuequestionaryquestionmatrixrowid"
                                               (click)="table.value = matrixcolumn.questionaryquestionmatrixrowid">
                                        <span title="{{ matrixcolumn.rowtitle }}">{{ matrixcolumn.rowtitle }}</span>
                                    </label>
                                </div>
                                <input class="othervalue" type="text" required typeof="text" placeholder="Enter Other value" *ngIf="matrixcolumn.other == 1" [hidden]="table.value != matrixcolumn.questionaryquestionmatrixrowid" [name]="getMatrixName(table.questionaryquestionid, matrixrow.questionaryquestionmatrixcolumnid, matrixrow.pagenumber, table.questionaryquestiontypecode) + '_othervalue'" [ngModel]="matrixcolumn.othervalue" />

                                <!-- set table value -->
                                {{ setTableValue(table.questionaryquestionid, matrixcolumn.valuequestionaryquestionmatrixrowid) }}

                            </ng-container>
                        </ng-container>
                    </div>

                </div>

                <!-- matrix multi column -->
                <div *ngIf="table.questionaryquestiontypecode == 'matrixmulticolumn'">

                    <!-- question title -->
                    <div *ngIf="table.title != '' && table.questionwithrequired == 1" class="questiontitle" data-pictos-questionary-required="&#xF069;" title="Answer required.">{{ table.title }}</div>
                    <div *ngIf="table.title != '' && table.questionwithrequired != 1" class="questiontitle">{{ table.title }}</div>

                    <!-- question description -->
                    <div *ngIf="table.description != ''" class="questiondescription" [innerHTML]="table.description | safeHtml"></div>

                    <!-- question content -->
                    <div>

                        <!-- description -->
                        <div *ngIf="getMatrixFirst(table.questionaryquestionid).description != ''" class="questiondescription" [innerHTML]="getMatrixFirst(table.questionaryquestionid).description | safeHtml"></div>

                        <!-- matrix table -->
                        <table cellspacing="0" cellpadding="0" class="questionmatrix questionmatrix_{{table.questionaryquestionid}}">
                            <ng-container *ngFor="let matrixrow of getMatrixRows(table.questionaryquestionid, getMatrixFirst(table.questionaryquestionid).columncount); let matrixrowindex = index;">

                                <!-- top header -->
                                <thead *ngIf="matrixrowindex == 0">
                                    <tr class="questionmatrixmulticolumnheaderline">
                                        <th class="questionmatrixmulticolumnoptionlineempty"></th>
                                        <th class="questionmatrixmulticolumnheader" *ngFor="let matrixcolumn of getMatrixRowColumns(table.questionaryquestionid, getMatrixFirst(table.questionaryquestionid).columncount, matrixrowindex); let matrixcolumnindex = index;">
                                            {{ matrixcolumn.columntitle }}
                                        </th>
                                    </tr>
                                </thead>

                                <tr class="questionmatrixmulticolumnrowhighlight {{ errors != '' && isInvalid(questionaryform, getMatrixName(table.questionaryquestionid, matrixrow.questionaryquestionmatrixrowid, matrixrow.pagenumber, table.questionaryquestiontypecode)) ? 'invalidrow': '' }}">

                                    <ng-container *ngFor="let matrixcolumn of getMatrixRowColumns(table.questionaryquestionid, getMatrixFirst(table.questionaryquestionid).columncount, matrixrowindex); let matrixcolumnindex = index;">

                                        <!-- row label -->
                                        <th (click)="tooltipIntoView($event)" class="questionmatrixmulticolumnoptionline" *ngIf="matrixcolumnindex == 0" [ngClass]="{'questionmatrixmulticolumntooltip': matrixcolumn.rowdescription}">
                                            <span *ngIf="!matrixcolumn.rowdescription">{{ matrixcolumn.rowtitle }}</span>
                                            <span *ngIf="matrixcolumn.rowdescription" data-pictos-questionary="&#xF05A;">{{ matrixcolumn.rowtitle }}</span>
                                            <div *ngIf="matrixcolumn.rowdescription" [ngClass]="{'tooltiptexttop': matrixrowindex > 0, 'tooltiptextbottom': matrixrowindex == 0}" [innerHTML]="matrixcolumn.rowdescription | safeHtml"></div>
                                        </th>

                                        <!-- cell -->
                                        <td [attr.data-th]="matrixcolumn.columntitle" (click)="matrixrow.value = matrixcolumn.questionaryquestionmatrixcolumnid; matrixcolumn.valuequestionaryquestionmatrixcolumnid = matrixcolumn.questionaryquestionmatrixcolumnid;" class="questionmatrixmulticolumncell" *ngIf="table.questionaryquestiontypecode == 'matrixmulticolumn' && getMatrixFirst(table.questionaryquestionid).multiselection == 0 && getMatrixFirst(table.questionaryquestionid).questionaryquestionmatrixorientationid != 2">
                                            <input *ngIf="matrixcolumnindex == 0" type="hidden" [required]="matrixcolumn.required" pattern="^[1-9]\d*$" [name]="getMatrixName(table.questionaryquestionid, matrixrow.questionaryquestionmatrixrowid, matrixrow.pagenumber, table.questionaryquestiontypecode)" [(ngModel)]="matrixrow.value" />

                                            <input type="radio" class="matrix-radio"
                                                   [id]="getMatrixName(table.questionaryquestionid, matrixrow.questionaryquestionmatrixrowid, matrixrow.pagenumber, table.questionaryquestiontypecode) + '_' + matrixcolumn.questionaryquestionmatrixcolumnid + '_radio'"
                                                   [name]="getMatrixName(table.questionaryquestionid, matrixrow.questionaryquestionmatrixrowid, matrixrow.pagenumber, table.questionaryquestiontypecode) + '_radio'"
                                                   [value]="matrixcolumn.questionaryquestionmatrixcolumnid"
                                                   [checked]="matrixcolumn.questionaryquestionmatrixcolumnid == matrixcolumn.valuequestionaryquestionmatrixcolumnid"
                                                   (click)="matrixrow.value = matrixcolumn.questionaryquestionmatrixcolumnid" />
                                            <label title="{{matrixcolumn.columntitle}}" for="{{getMatrixName(table.questionaryquestionid, matrixrow.questionaryquestionmatrixrowid, matrixrow.pagenumber, table.questionaryquestiontypecode) + '_' + matrixcolumn.questionaryquestionmatrixcolumnid + '_radio'}}"></label>
                                        </td>

                                    </ng-container>
                                </tr>
                            </ng-container>
                        </table>
                    </div>
                </div>

                <!-- text multi row -->
                <div *ngIf="table.questionaryquestiontypecode == 'textmultirow'">

                    <!-- question title -->
                    <div *ngIf="table.title != '' && table.questionwithrequired == 1" class="questiontitle" data-pictos-questionary-required="&#xF069;" title="Answer required.">{{ table.title }}</div>
                    <div *ngIf="table.title != '' && table.questionwithrequired != 1" class="questiontitle">{{ table.title }}</div>

                    <!-- question description -->
                    <div *ngIf="table.description != ''" class="content" [innerHTML]="table.description | safeHtml"></div>

                    <!-- questions: constant sum -->
                    <div *ngFor="let question of getTable4Field(table.questionaryquestionid); let questionindex = index;">

                        <!-- question: constant sum -->
                        <div class="row">
                            <div *ngIf="question.title != ''" class="col-md-12 questionconstantsumline">
                                {{ question.title }}
                            </div>
                        </div>

                        <!-- slider with current value -->
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row vertical-alignment-container">
                                    <!-- slider -->
                                    <div class="col-10">
                                        <mat-slider name="field_{{question.questionaryquestionid}}_{{question.questionaryquestionfieldid}}_{{question.pagenumber}}" [(ngModel)]="question.value" (input)="question.value = $event.value" thumbLabel="true" step="1" min="0" max="100" (change)="setSliderChanged($event, getSliderSum(getTable4Field(table.questionaryquestionid), table.questionaryquestionid), question.value, question.questionaryquestionid, question.questionaryquestionfieldid)"></mat-slider>
                                    </div>
                                    <!-- selected value -->
                                    <div class="col-2 questionconstantsumslidervalue">
                                        {{question.value}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- constant sum total -->
                    <div class="row">
                        <div class="col-12">
                            <div class="row vertical-alignment-container">
                                <div class="col-10 questionconstantsumtotallabel">Total</div>
                                <div class="col-2 questionconstantsumtotal">
                                    <input type="text" [required]="table.required" name="sum_{{table.questionaryquestionid}}" [(ngModel)]="table.sum" pattern="^100$" class="questionconstantsumtotal" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- slider sum -->
                    <div class="hidden">
                        {{ getSliderSum(getTable4Field(table.questionaryquestionid), table.questionaryquestionid) }}
                    </div>

                </div>

                <!-- text fields -->
                <div *ngIf="table.questionaryquestiontypecode == 'text'">
                    <div *ngFor="let question of getTable4Field(table.questionaryquestionid); let questionindex = index;">
                        <div class="row">

                            <!-- question title -->
                            <div *ngIf="table.title != '' && table.questionwithrequired == 1" class="col-md-12 questiontitle" data-pictos-questionary-required="&#xF069;" title="Answer required.">{{ table.title }}</div>
                            <div *ngIf="table.title != '' && table.questionwithrequired != 1" class="col-md-12 questiontitle">{{ table.title }}</div>

                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <input placeholder="Enter an Email Address" autofocus *ngIf="question.questionarydatatypecode == 'EMAIL'" [required]="question.required" type="text" maxlength="255" class="form-control" [(ngModel)]="question.value" name="field_{{question.questionaryquestionid}}_{{question.questionaryquestionfieldid}}_{{question.pagenumber}}" email="true" autocomplete="off">
                            </div>
                            <div class="col-md-6"></div>
                        </div>
                        <div class="row" *ngIf="question.description != ''">
                            <div class="col-md-12 questiondescription" [innerHTML]="question.description | safeHtml"></div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- spacer -->
            <br /><br />

            <!-- form errors -->
            <div *ngIf="errors != ''" class="errors">
                <span data-pictos-errors="&#xF06A;"></span>
                <b>There are some errors, please correct them:</b><br /><br />
                <div class="content" [innerHTML]="errors | safeHtml"> </div>
                <br /><br />
            </div>

            <!-- buttons/navigation/functions -->
            <div class="row vertical-alignment-container">
                <div class="col-lg-2">
                    <!-- continue -->
                    <div *ngIf="pagenumber != maxpages" (click)="showbadge == false && loadQuestionary(questionaryform, 1)" [ngClass]="{'bluebuttonwicon': showbadge == false, 'disabledbuttonwicon': showbadge == true}">
                        <span data-pictos-button="&#xF054;">Continue</span>
                    </div>
                    <!-- submit -->
                    <div *ngIf="pagenumber == maxpages" (click)="showbadge == false && loadQuestionary(questionaryform, 1)" [ngClass]="{'greenbuttonwicon': showbadge == false, 'disabledbuttonwicon': showbadge == true}">
                        <span data-pictos-button="&#xF00C;">Submit</span>
                    </div>
                </div>
                <div class="col-lg-6">
                    <!-- back -->
                    <button *ngIf="pagenumber > 1" (click)="loadQuestionary(null, 0);" class="non-primary-button">Go back</button>
                </div>
                <!-- progress spinner -->
                <div class="col-lg-1">
                    <div class="mat-progress-spinner" *ngIf="progressinpercent > 0">
                        <div class="spinner-background">&nbsp;{{spinner.value}}%</div>
                        <mat-progress-spinner #spinner
                                              diameter="45"
                                              strokeWidth="3"
                                              mode="determinate"
                                              value="{{progressinpercent}}">
                        </mat-progress-spinner>
                    </div>
                </div>
                <!-- save and continue later-->
                <div *ngIf="pagenumber != maxpages" class="col-lg-3">
                    <button *ngIf="pagenumber > 1" class="save-button" (click)="openQuestionarySaveDialog(questionaryform)">Save and Continue Later</button>
                </div>
            </div>

            <!-- submit info -->
            <div *ngIf="pagenumber == maxpages" class="row">
                <div class="col-lg-12">
                    <span class="info">
                        This will submit and process your answers.
                    </span>
                </div>
            </div>

            <!-- separator -->
            <br /><br />

            <!-- badges: recognizing your achievements -->
            <div *ngIf="arrBadges.length > 0 && arrTable[0].questionaryanswerstatusid == 1 && pagenumber != maxpages">
                <h4 class="badgetitle">Recognize your progress ...</h4>
                <div *ngFor="let table of arrBadges" class="badges">
                    <div class="badgeframe" title="{{table.questionaryquestionbadgetitle}}"><img src="/images/svgs/{{table.questionaryquestionbadgecode}}.svg" [ngClass]="{'badgeenabled': table.show == 1, 'badgedisabled': table.show == 0}" /></div>
                </div>
            </div>

        </div>
    </div>
</form>

<!-- questionary badge -->
<app-questionary-badge *ngIf="showbadge" (badgeanimationendevent)="badgeanimationendevent($event)" [questionaryquestionbadgecode]="questionaryquestionbadgecode" [questionaryquestionbadgetitle]="questionaryquestionbadgetitle" [questionaryquestionbadgemessage]="questionaryquestionbadgemessage"></app-questionary-badge>

<!-- completed info -->
<div *ngIf="arrTable[0] && arrTable[0].questionaryanswerstatusid == 2" id="mainq">
    <div class="container completionwrapper" *ngFor="let table of arrTable">

        <!-- title -->
        <div class="row" *ngIf="table.title != ''">
            <div class="col-0 col-md-2"></div>
            <div class="completiontitle col-12 col-md-8" [innerHTML]="table.completiontitle | safeHtml"></div>
            <div class="col-0 col-md-2"></div>
        </div>

        <!-- content -->
        <div class="row" *ngIf="table.completioncontent != ''">
            <div class="col-0 col-md-2"></div>
            <div class="completioncontent col-12 col-md-8" [innerHTML]="table.completioncontent | safeHtml"></div>
            <div class="col-0 col-md-2"></div>
        </div>

        <!-- answer email present: email with report was sent -->
        <div class="row" *ngIf="table.questionansweremail != ''">
            <div class="col-0 col-md-2"></div>
            <div class="completioncontent col-12 col-md-8">
                <strong>I hope the assessment report sent to your provided email address will help your organization assess AI readiness and recognize AI technologies' opportunities and potential.</strong> If you don't receive the message, check your SPAM folder. You can also download it directly.
            </div>
            <div class="col-0 col-md-2"></div>
        </div>

        <!-- answer email present: direct report download -->
        <div class="row" *ngIf="table.questionansweremail == ''">
            <div class="col-0 col-md-2"></div>
            <div class="completioncontent col-12 col-md-8">
                <strong>I hope <a target="_blank" [attr.href]="'/ai-assessment-report/' + questionaryanswerhashcode">the assessment report</a> will help your organization assess AI readiness and recognize AI technologies' opportunities and potential.</strong>
            </div>
            <div class="col-0 col-md-2"></div>
        </div>
        
    <!-- button: direct report download -->
        <div class="row framemargintop">
            <div class="col-12 framealigncenter">
                <a class="bluebuttonwicon" target="_blank" [attr.href]="'/ai-assessment-report/' + questionaryanswerhashcode">
                    <span data-pictos-button="&#xF019;">Download Your Assessment Report</span>
                </a>
            </div>
        </div>

        <!-- share -->
        <div class="row framemargintop">
            <div class="col-1 col-md-3"></div>
            <div class="col-10 col-md-6 frameflat">
                <div class="frameflattitle">
                    If you found the research interesting and the results helpful, <br /><strong>please share</strong> with others.
                </div>
                <a target="_blank" href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https://www.aibusinessresearch.eu&amp;title=AI Business Research Survey&amp;summary=A comprehensive EU study on how to improve business processes using Artificial Intelligence.&amp;source=https://www.aibusinessresearch.eu" data-pictos-share="&#xF08C;" class="frameflaticonlinkedin"></a>
                <a target="_blank" href="https://www.facebook.com/sharer.php?u=https://www.aibusinessresearch.eu" data-pictos-share="&#xF082;" class="frameflaticonfacebook"></a>
                <a target="_blank" href="https://twitter.com/intent/tweet/?text=AI Business Research Survey&amp;url=https://www.aibusinessresearch.eu" data-pictos-share="&#xF099;" class="frameflaticontwitter"></a>
                <a target="_blank" href="mailto:?subject=AI Business Research Survey&amp;body=A comprehensive EU study on how to improve business processes using Artificial Intelligence. https://www.aibusinessresearch.eu" data-pictos-share="&#xF0E0;" class="frameflaticonmail"></a>
            </div>
            <div class="col-1 col-md-3"></div>
        </div>

        <!-- read more -->
        <div class="row framemargintop">
            <div class="col-12 framealigncenter">
                <a class="bluebuttonwicon" href="https://www.aibusinessresearch.eu">
                    <span data-pictos-button="&#xF10E;">Read more</span>
                </a>
            </div>
        </div>

        <!-- you have done well -->
        <div class="row framemargintopdouble">
            <div class="col-12 framealigncenter">
                <h4 class="badgetitle">BTW, you have done well!</h4>
                <div *ngFor="let table of arrBadges" class="badges">
                    <div class="badgeframe" title="{{table.questionaryquestionbadgetitle}}"><img src="/images/svgs/{{table.questionaryquestionbadgecode}}.svg" [ngClass]="{'badgeenabled': table.show == 1, 'badgedisabled': table.show == 0}" /></div>
                </div>
            </div>
        </div>

    </div>
</div>